<template>
    <div>
        <vs-popup
            title="Atendimentos em pesquisa"
            :active="active"
            @close="$emit('activeFalse')"
        >
            <div class="p-3 font-bold">
                Este Usuário tem atendimentos em aberto! <br> <br>

                Para deletar o usuário espere o cliente responder a pesquisa,
                ou finalize os antendimentos aqui mesmo.
            </div>

            <div>
                    <vs-table
                        ref="table"
                        noDataText="Sem dados disponíveis"
                        pagination
                        :max-items="4"
                        :data="tickets"
                    >
                        <template slot="thead">
                            <vs-th>Contato</vs-th>
                            <vs-th>Número</vs-th>
                            <vs-th>Conexão</vs-th>
                            <vs-th>Status</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td>
                                        <p>
                                            {{ tr.customer.name }}
                                        </p>
                                    </vs-td>

                                    <vs-td>
                                        <p>
                                            {{ maskPhoneNumber(tr.customer.phone_number) }}
                                        </p>
                                    </vs-td>
                                       
                                    <vs-td>
                                         <p>
                                            {{ tr.instance.nickname || tr.instance.name }}
                                        </p>
                                    </vs-td>

                                    <vs-td>
                                        <vs-chip color="#0C2860">
                                            Pesquisa
                                        </vs-chip>
                                    </vs-td>
                                </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>

                    <vs-button @click="confirmToFinish">
                        Finalizar {{ tickets.length > 1 ? 'todos os atendimentos' : 'o atendimento' }}
                    </vs-button>
            </div>
            
        </vs-popup>
    </div>
</template>

<script>
import { maskPhoneNumber } from "@/utils";
import { finishManyChatTicket } from '@/http/requests/chatTicket';

export default {
    methods:{
        maskPhoneNumber,
        finishTickets() {
            const ticketsIds = this.tickets.map(ticket => ticket.id);

            finishManyChatTicket(JSON.stringify(ticketsIds), 'many_from_user')
            .then(() => {
                this.$vs.notify({
                  color: 'success',
                  title: 'Sucesso!',
                  text: `Os atendimentos foram finalizados! Agora é possivel deletar o usuário!`,
                  time: 7000,
                })
                this.$emit('openToDeleteUser')
            })
            .catch((error) => {
                console.log(error)
            })
        },
        confirmToFinish() {
            this.$emit('activeFalse');

            this.$vs.dialog({
                type:'confirm',
                color: 'warning',
                title: `Atenção!`,
                text: 'Tem certeza de que deseja finalizar todos os atendimentos selecionados?',
                accept: () => this.finishTickets(),
                cancel: () => this.$emit('activeTrue'),
                acceptText: 'Sim',
                cancelText: 'Voltar',
            })
        }
    }, 
    props: {
        active: {
            type: Boolean,
            required: true
        },
        tickets : {
            type: Array|Object,
            required: true
        }
    }
}

</script>
